import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  AllDoctorsType,
  BookingListType,
  DepartmentTypes,
  DoctorsType,
  // PatientFullDetailsType,
  SaveParamsType,
  SavePayloadType,
  TimeSlotPayloadType,
  TimeSlotType,
} from "./types";
// import { oldInstance } from "../../services/services";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId,createdById} = getConstants()
const { patientBookingApi } = api;

export const getTimeSlotes = async (
  params: Omit<TimeSlotPayloadType, "clinicId">
): Promise<ResponseType<TimeSlotType[]>> => {
    const result = (
      await instance.post(patientBookingApi.getTimeSlot, {
        ...params,
        clinicId,
      })
    ).data;
    return result;
};

export const getAllDoctors = async (clinicid:number | null | undefined): Promise<
  ResponseType<AllDoctorsType[]>
> => {

  const result = (
    await instance.get(`${patientBookingApi.alldoctors}${ clinicid ? clinicid : clinicId}`)
  ).data;
  return result;
};

export const getDoctorsByDepartment = async ({
  departmentId,
  selectedTime,
  dayId,
}: {
  departmentId: number;
  selectedTime: string;
  dayId: number;
}): Promise<ResponseType<DoctorsType[]>> => {
    const result = (
      await instance.post(`${patientBookingApi.getDoctorByDepartment}`, {
        clinicId,
        departmentId,
        selectedTime,
        dayId,
      })
    ).data;
    return result;
};

export const getAllDepattment = async (): Promise<
  ResponseType<DepartmentTypes[]>
> => {
    const result = (
      await instance.get(`${patientBookingApi.getAllDepartments}${clinicId}`)
    ).data;
    return result;
};

export const saveAppointments = async ( params: SaveParamsType ): Promise<ResponseType<string | null>> => {
  const body: SavePayloadType = {
    ...params,
    clinicId,
    createdByUserId: createdById as number,
    ip: "",
    createdDate: "",
    bookingConfirmed:params.bookingConfirmed ?? 0,
  };
if(params?.id){
  return (await instance.put(patientBookingApi.saveBooking, body))
    .data;
}else{
  return (await instance.post(patientBookingApi.saveBooking, body))
    .data;
}
};


export const getAllBookings = async ({
  startTime,
  endTime,
  departmentId = null,
  doctorId = null,
}: {
  startTime: string;
  endTime: string;
  departmentId: number | null;
  doctorId: number | null;
}): Promise<ResponseType<BookingListType>> => {
  const result = (
    await instance.post(patientBookingApi.getAllBookings, {
      departmentId,
      doctorId,
      startTime,
      endTime,
      clinicId,
    })
  ).data;
  return result;
};

export const updateBookings = async (params: {
  bookingId: number;
  doctorId: number;
  startBookingDate: string;
  endBookingDate: string;
}): Promise<ResponseType<string | null>> => {
  return (await instance.post(patientBookingApi.changeSlot,{...params,clinicId})).data;
};

export const cancelBooking = async (id: string): Promise<ResponseType<string|null>> => {
  return await instance.delete(`${patientBookingApi.deleteBooking}${clinicId}?bookingId=${id}`)
};

// export const getSearchedPatientByEMR = async (
//   emrno: string
// ): Promise<PatientFullDetailsType | null> => {
//   const body = { emrno, clinicId };
//   try {
//     const result = await oldInstance.post(
//       "/rcm/admin/patientreg/getPatientByEmr?access_token=" + user?.refreshtoken,
//       body
//     );
//     return result?.data;
//   } catch (error) {
//     return null;
//   }
// };

export const getRegisteredpatients = async (id:number) => {
  console.log(id);
  return [];
};

export const getPatientById = async (id: any) => {
  console.log(id);

  try {
  } catch (error) {
    return {};
  }
};
export const changeQueuestatus = async ({ id, status }: any) => {
  console.log(id, status);

  try {
    //Success
  } catch (error) {
    return "Something went wrong";
  }
};
